import { Container } from '@dapperlabs/core-fe';
import React from 'react';

interface Props {
  children: React.ReactElement;
}

const SectionContainer: React.FC<Props> = ({ children }) => {
  return (
    <Container
      as='section'
      maxW={['375px', '375px', '75rem']}
      pt={['3rem', '3rem', '6.5rem']}
      px={['1rem', '1rem', '1rem', '1rem', 0]}
    >
      {children}
    </Container>
  );
};

export default SectionContainer;
